<template>
  <div id="calendar" class="calendar">
    <Confirmation
      v-if="showConfirmation"
      @resetBooking="
        showConfirmation = false;
        $store.commit('setSelectedBooking', '');
        selectedGuests = 0;
        currentGuestInfo = undefined;
        firstName = '';
        lastName = '';
        emailAddress = '';
        phoneNumber = '';
        notes = '';
      "
      :response="bookingResponse"
    />
    <div v-if="!showConfirmation && $store.state.schedules.length > 1" style="justify-content: center" >
      <div>
        <h2>Select Appointment Type</h2>
        <div class="schedules">
          <Button
            :class="{
              selected: $store.state.selectedSchedule === schedule.value,
            }"
            alternateTheme
            v-for="schedule in $store.state.schedules"
            :text="schedule.name"
            link=""
            @click="
              $store.state.availableBookings = [];
              $store.commit('setSelectedBooking', '');
              $store.commit('setSelectedSchedule', schedule.value);
            "
          />
        </div>
      </div>
    </div>
    <div v-if="!showConfirmation && $store.state.schedules.length > 1 && $store.state.selectedSchedule === 'sch-a'" style="justify-content: center" >
      <div>
        <h3 style="width:575px; text-transform:none; font-family:'Modern Era'; color:var(--red); padding: 20px 12px;"><span style="text-transform:uppercase; font-weigt:normal; font-family: 'Sharp Grotesk';">Attention:</span> In-person meetings take place at our headquarters in Little Italy.</h3>        
      </div>
    </div>
    <div
      v-if="!showConfirmation"
      :class="{
        'date-not-chosen': $store.state.availableBookings.length === 0,
      }"
    >
      <div>
        <h2>Select Date</h2>
        <div class="holder">
          <div class="ui">
            <ArrowButton @click="changeMonth(-1)" />
            <h3>{{ month }}</h3>
            <ArrowButton next @click="changeMonth(1)" />
          </div>
          <div class="days">
            <div>S</div>
            <div>M</div>
            <div>T</div>
            <div>W</div>
            <div>T</div>
            <div>F</div>
            <div>S</div>
          </div>
          <div class="month">
            <Day
              v-for="day in content"
              :date="day.date"
              :day="day.day"
              :disabled="day.disabled"
            />
          </div>
        </div>
      </div>
      <div
        v-show="$store.state.availableBookings.length !== 0"
        id="available-times"
      >
        <transition name="fade" appear>
          <div>
            <h2>Select Time</h2>
            <AvailableTimes />
          </div>
        </transition>
      </div>
      <div
        id="form"
        class="details"
        v-if="$store.state.selectedBooking !== ''"
        :class="{ 'show-errors': showErrors }"
      >
        <transition name="fade" appear>
          <div>
            <h2>Enter Details</h2>
            <div class="holder" style="min-width: 300px">
              <table>
                <tr>
                  <td class="label-holder">
                    <span class="label">*First Name</span>
                  </td>
                  <td>
                    <input
                      :class="firstName !== '' ? 'has-value' : 'has-error'"
                      type="text"
                      name="firstname"
                      id="firstname"
                      v-model="firstName"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label-holder">
                    <span class="label">*Last Name</span>
                  </td>
                  <td>
                    <input
                      :class="lastName !== '' ? 'has-value' : 'has-error'"
                      type="text"
                      name="lastname"
                      id="lastname"
                      v-model="lastName"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label-holder">
                    <span class="label">*Email Address</span>
                  </td>
                  <td>
                    <input
                      :class="[
                        emailAddress !== '' ? 'has-value' : '',
                        emailAddress !== '' && testEmail.test(emailAddress)
                          ? ''
                          : 'has-error',
                      ]"
                      type="email"
                      name="email"
                      id="email"
                      v-model="emailAddress"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label-holder">
                    <span class="label">*Phone Number</span>
                  </td>
                  <td>
                    <input
                      :class="[
                        phoneNumber === '' ? 'has-value' : '',
                        phoneNumber !== '' &&
                        phoneNumber.replace(/\D/g, '').length < 10
                          ? 'has-error'
                          : '',
                      ]"
                      type="tel"
                      name="phonenumber"
                      id="phonenumber"
                      v-model="phoneNumber"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label-holder">
                    <span class="label">Company</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="company"
                      id="company"
                      v-model="company"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label-holder">
                    <span class="label">Language</span>
                  </td>
                  <td>
                    <select name="language" id="language" v-model="selectedLanguage">
                      <option value="english">English</option>
                      <option value="spanish">Spanish</option>
                    </select>
                  </td>
                </tr>
                   <tr>
                  <td class="label-holder">
                    <span class="label">Notes</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="notes"
                      id="notes"
                      v-model="notes"
                    />
                  </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="check-holder" >
                            <input type="checkbox" name="infoConsent" id="infoConsent" v-model="infoConsent" />
                            <label for="infoConsent">
                                By checking this box, I hereby consent to receive additional information from San Diego FC, Major League Soccer, Soccer United Marketing and its marketing partners in accordance with the
                                <a href="https://www.mlssoccer.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">MLSsoccer.com Privacy Policy</a> and<a href="https://www.mlssoccer.com/legal/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>.</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="check-holder" :class="consent ? '' : 'has-error'">
                            <input type="checkbox" name="consent" id="consent" v-model="consent" />
                            <label for="consent">
                                *I consent to the processing of the personal information provided herein in accordance with Major League Soccer’s
                                <a href="https://www.mlssoccer.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.mlssoccer.com/legal/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>.</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="check-holder">
                            <input type="checkbox" name="textConsent" id="textConsent" v-model="textConsent" />
                            <label for="textConsent">
                                I  agree to receive marketing and promotional text messages from San Diego FC, Major League Soccer, and their affiliates or service providers on their behalf at the phone number I have provided, including through the use of automated dialing technologies. I understand that this is not a condition of any purchase. Message and data rates may apply. Message frequency varies. Reply STOP to any text message to unsubscribe.
                            </label>
                        </div>
                    </td>
                </tr>
                
                <tr class="guests">
                  <td class="label-holder">
                    <span class="label"
                      >Additional Attendees<sub>(Up to 3)</sub></span
                    >
                  </td>
                  <td>
                    <div class="guest-options">
                      <GuestButton
                        v-for="guest in 4"
                        :key="guest"
                        :text="String(guest - 1)"
                        :class="{ selected: selectedGuests === guest - 1 }"
                        @click="selectedGuests = guest - 1"
                      />
                    </div>
                  </td>
                </tr>
              </table>
              <Button
                text="Add Guest Details"
                style="width: 100%"
                link=""
                @click="errorsInForm ? null : (showGuestsModal = true)"
                class="submit"
                :class="{ disabled: errorsInForm }"
                v-if="selectedGuests > 0"
              />
              <Button
                v-else
                text="Book Now"
                style="width: 100%"
                link=""
                @click="submitAppointment"
                class="submit"
                :class="{ disabled: errorsInForm }"
              />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
  <GuestModal
    v-if="showGuestsModal"
    :numGuests="selectedGuests"
    :currentGuestInfo="currentGuestInfo"
    @addGuest="selectedGuests = selectedGuests + 1"
    @removeGuest="selectedGuests = selectedGuests - 1"
    @close="showGuestsModal = false"
    @done="setGuests"
    @submitAppointment="submitAppointment"
  />
</template>

<script>
import axios from "axios";
import { format, add } from "date-fns";
import ArrowButton from "@/components/ArrowButton";
import GuestButton from "@/components/GuestButton";
import Button from "@/components/Button";
import AvailableTimes from "@/components/AvailableTimes";
import GuestModal from "@/components/GuestModal";
import Day from "@/components/Day";
import Confirmation from "@/components/Confirmation";
export default {
  name: "Form",
  created() {
    this.now = new Date();
    this.getMonth();
  },
  data() {
    return {
      month: "",
      content: "",
      now: undefined,
      selectedGuests: 0,
      showGuestsModal: false,
      currentGuestInfo: undefined,
      showConfirmation: false,
      testEmail: /^.+@.+\..+$/,
      showErrors: false,
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "",
      notes: "",
      company: "",
      infoConsent: "",
      consent: true,
      textConsent: "",
      selectedLanguage: "english",
      bookingResponse: {},
    };
  },
  components: {
    Button,
    ArrowButton,
    Day,
    AvailableTimes,
    GuestButton,
    GuestModal,
    Confirmation,
  },
  computed: {
    selectedSchedule() {
      return this.$store.state.selectedSchedule;
    },
    source() {
      const url = new URL(window.location.href);
      const searcParams = new URLSearchParams(url.search);
      return searcParams.get('src') ?? '';
    },
    errorsInForm() {
      let errors = [];
      this.consent ? "" : errors.push("consent");
      this.firstName !== "" ? "" : errors.push("first-name");
      this.lastName !== "" ? "" : errors.push("last-name");
      this.phoneNumber !== "" ? "" : errors.push("phone-number");
      this.emailAddress !== "" && this.testEmail.test(this.emailAddress)
        ? ""
        : errors.push("email-address");
      //this.phoneNumber !== "" ? "" : errors.push("phone-number");
      this.phoneNumber !== "" && this.phoneNumber.replace(/\D/g, "").length < 10
        ? errors.push("phone-number")
        : "";
      return errors.length > 0;
    },
  },
  methods: {
    submitAppointment() {
      if (this.errorsInForm) {
        this.showErrors = true;
        return;
      }
      

      let combinedNotes = this.notes.trim();
      combinedNotes = `${combinedNotes} Language Preference: ${this.selectedLanguage} Additional Information Consent: ${this.infoConsent ? "Yes" : "No"} Personal Information Consent: ${this.consent ? "Yes" : "No"} Text Consent: ${this.textConsent ? "Yes" : "No"} Appointment Source: ${this.source} `;
      this.showGuestsModal = false;
      const params = new URLSearchParams();
      params.append("appointment", this.$store.state.selectedBooking);
      params.append("first", this.firstName.trim());
      params.append("last", this.lastName.trim());
      params.append("email", this.emailAddress.trim());
      params.append("phone", this.phoneNumber.trim().replace(/\D/g, ""));
      params.append("company", this.company.trim());
      params.append("notes", combinedNotes.trim());
      params.append("guests", this.selectedGuests);

      if (this.selectedGuests > 0) {
        this.currentGuestInfo.forEach((element, id) => {
          params.append(`guestDetails[${id}][first]`, element.first);
          params.append(`guestDetails[${id}][last]`, element.last);
          params.append(`guestDetails[${id}][email]`, element.email);
          //guestDetails[0][first]: gf
          //guestDetails[0][last]: gl
          //guestDetails[0][email]: richard@channel1media.com
        });
      }

      params.append("display", "");
      params.append("address", "");
      params.append("purl", this.$route.params.purl);
      params.append("schedule", this.$store.state.selectedSchedule);
      axios
        .post(`${this.$store.state.API}/Appointment.php`, params)
        .then(this.onSubmitAppointment);
    },
    onSubmitAppointment(response) {
      if (response.data.status == "ok") {
        this.showConfirmation = true;
        this.bookingResponse = response.data;
      } else {
        alert("An error occurred getting the month");
      }
    },
    setGuests(guests) {
      this.selectedGuests = guests.length;
      this.currentGuestInfo = guests;
    },
    changeMonth(months) {
      this.now = add(this.now, { months: months });
      this.getMonth();
    },
    getMonth() {
      const params = new URLSearchParams();
      params.append("month", format(this.now, "M"));
      params.append("year", format(this.now, "yyyy"));
      params.append("schedule", this.$store.state.selectedSchedule);
      axios
        .post(`${this.$store.state.API}/Calendar.php`, params)
        .then(this.onGetCalendar);
    },
    onGetCalendar(response) {
      if (response.data.status == "ok") {
        this.month = response.data.month;
        this.content = response.data["json-content"];
      } else {
        alert("An error occurred getting the month");
      }
    },
  },
  watch: {
    selectedSchedule(newValue) {
      this.content = "";
      this.getMonth();
    },
  },
};
</script>

<style lang="scss" scoped>
.check-holder {
    display: flex;
    gap: 10px;
    white-space: normal;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-family: 'Modern Era';
    &.has-error {
      padding:10px;
    }
    input {
        accent-color: #0479E8;
        width: 20px;
    }
    a {
        font: inherit;
        font-weight: bold;
        color: inherit;
        display: inline-block;
    }
    label {
        flex-grow: 1;
    }
}
.schedules {
  display: flex;
  flex-direction: row;
  //min-width: 450px;
  margin-top: 30px;
  > * {
    flex-grow: 1;
    width: 50%;    
    padding: 6px;
  }
  @media (min-width: 600px) {
    //flex-direction: row;
  }
}
.parking-holder {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.schedule-type {
  text-align: center;
  color: var(--white);  
  margin-top: 75px;
  margin-bottom: 20px;
  font-size: 1.375rem;
  border: none;
}
p {
  text-align: center;
  color: var(--white);
  font-weight: 300;
  font-size: 1rem;
  max-width: 715px;
  margin: 0 auto;
}
select {
  font-weight: bold;
  font-size: 1rem;
  color: var(--white);
  width: 100%;
  padding: 12px 15px;
  border: none;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='%230479E8' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>")
    no-repeat;
  background-color: rgba(0, 0, 0, 0.4);
  background-position: calc(100% - 0.75rem) center !important;
  &.has-error {    
    border: 1px solid var(--red);
    color: var(--white);
  }
}
.submit {
  position: relative;
  &:after {
    content: "fill in required fields to proceed";
    background: linear-gradient(180deg, #ab0808 0%, #f33 100%);
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
    color: var(--dark-red);
    font-size: 0.8em;
  }
  &.disabled {
    opacity: 0.3;
    border: 1px solid var(--accent);
    overflow: hidden;
    &:hover {
      opacity: 1;
      &:after {
        opacity: 1;
      }
    }
  }
}
table {
  border-collapse: separate;
  border-spacing: 0 10px;
  table-layout: fixed;
}
table {
  color: var(--white);
  text-align: left;
  width: 100%;

  td {
    white-space: nowrap;
  }
  span {
    padding: 5px;
    padding-left: 0;
    font-family: 'Modern Era';
    font-size: 1rem;
    
  }
  .label-holder {
    width: 170px;
    sub {
      display: block;
    }
  }
  input {
    padding: 10px 15px;
    width: 100%;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.4);
    border: none;
    color: #fff;
    font-weight: bold;
    font-size: 1rem;
  }
  .guests td {
    padding: 20px 0;
  }
  .guest-options {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    justify-content: space-between;
    button {
      height: 30px;
      width: 30px;
    }
  }
}
.invitation {
  font-weight: 400;
  font-size: 10px;
  line-height: 1.6;
  font-style: italic;
  margin-top: 25px;
}
.details {
  flex-grow: 1;
  &.show-errors .has-error {
    border: 1px solid var(--red);
    color: var(--white);
  }
}
.holder {
  padding: 20px 30px;
}
h2 {
  color: var(--grey);
  padding: 20px 12px;
  margin: 0;
  font-size: 13px;
  text-transform: uppercase;
  text-align: center;
  border-bottom: 1px solid var(--grey);
  font-family: "Sharp Grotesk";  
  font-weight: normal;
}
h3 {
  color: var(--white);
  font-size: 1rem;
  text-transform: uppercase;  
  font-family: "Sharp Grotesk";  
  font-weight: normal;
}
.ui {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
#calendar {
  background: url("~@/assets/images/booking.jpg");
  background-size: cover;
  > div {
    overflow: hidden;
    max-width: 500px;
    margin: 25px auto;
    > div {
      background: var(--navy);
      h2 {
        margin: 0 30px;
      }
    }    
    @media (min-width: 1110px) {
      display: flex;
      gap: 5px;
      max-width: 1110px;
  //    margin: 75px auto;
      &.date-not-chosen {
        display: block;
        width: 540px;
      }
      > div {
        position: relative;
        &:after {
          content: "";
          height: 6px;
          background: var(--accent);
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          transition: width 0.2s ease-in-out;
        }
      }
    }    
  }
}
.days,
.month {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  place-items: center;
  gap:1px;
  @media (min-width: 415px) {
    gap: 10px;
  }
}
.month {
  grid-auto-rows: 40px;
}
.days {
  color: var(--white);
  font-size: 13px;  
  padding: 10px 0;  
}
.month {
  padding: 15px 0;
}
</style>